<template>
  <div>
    <v-card class="card--shadow">
      <v-card-title class="purple accent-4">
        <div class="subtitle-1 white--text text-uppercase">
          Diagnosis Edit Form
        </div>
      </v-card-title>
    </v-card>

    <!-- REFERRAL,SYMPTON SECTION -->
    <v-card class="card--shadow" v-if="data">
      <v-card-text>
        <v-row>
          <v-col lg="4">
            <label>Reg Date</label>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="data.register_date"
                  outlined
                  dense
                  readonly
                  persistent-hint
                  prepend-inner-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="data.register_date"
                no-title
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col lg="4">
            <label>Referral Type</label>
            <v-select
              :items="referralTypeOpt"
              v-model="data.referral_type_id"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col lg="4">
            <label>Referral From</label>
            <v-select
              :items="referralFromOpt"
              v-model.trim="data.referral_from_id"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col lg="8">
            <label>Sympton</label>
            <v-select
              :items="symptonOpt"
              v-model="data.symptons"
              multiple
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- WEIGHT & RISK FACTOR SECTION -->
    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="4">
            <label>Weight(Kg)</label>
            <v-text-field
              v-model.trim="data.weight"
              outlined
              dense
              type="number"
            ></v-text-field>
          </v-col>

          <v-col lg="6">
            <label>Risk Factors</label>
            <v-select
              :items="riskFactorOpt"
              v-model="data.risk_factors"
              multiple
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  
    <!-- HIV SECTION -->
    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="4">
            <label>HIV</label>
            <v-select
              :items="commonOpt"
              v-model="data.hiv_status"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col v-if="data.hiv_status == 3" lg="8">
            <v-row>
              <v-col class="col--padding" lg="4">
                <label>Date</label>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data.hiv_date"
                      outlined
                      dense
                      readonly
                      persistent-hint
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="data.hiv_date"
                    no-title
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="col--padding ml-1" lg="3">
                <label>Result</label>
                <v-select
                  :items="hivResult"
                  v-model="data.hiv_result"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col class="col--padding ml-1" lg="2">
                <label>Code</label>
                <v-text-field
                  v-model.trim="data.hiv_code"
                  type="text"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- SPUTUM SECTION -->
    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="4">
            <label>Sputum</label>
            <v-select
              :items="commonOpt"
              v-model="data.sputum_status"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col v-if="data.sputum_status == 3" lg="8">
            <v-row>
              <v-col class="col--padding" lg="4">
                <label>Date</label>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data.sputum_date"
                      outlined
                      dense
                      readonly
                      persistent-hint
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="data.sputum_date"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="col--padding ml-1" lg="3">
                <label>Result</label>
                <v-select
                  :items="sputumResult"
                  v-model="data.sputum_result"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- CXR SECTION -->
    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="4">
            <label>CXR</label>
            <v-select
              :items="commonOpt"
              v-model="data.cxr_status"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col v-if="data.cxr_status == 3" lg="8">
            <v-row>
              <v-col class="col--padding" lg="4">
                <label>Date</label>
                <v-menu
                  ref="menu3"
                  v-model="menu3"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data.cxr_date"
                      outlined
                      dense
                      readonly
                      persistent-hint
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="data.cxr_date"
                    no-title
                    @input="menu3 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="col--padding ml-1" lg="3">
                <label>Result</label>
           
                <v-select
                  v-model="data.cxr_result"
                  :items="cxrResult"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Gene Xpert SECTION -->
    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="4">
            <label>Gene Xpert</label>
            <v-select
              :items="commonOpt"
              v-model="data.gene_xpert_status"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col v-if="data.gene_xpert_status == 3" lg="8">
            <v-row>
              <v-col class="col--padding" lg="4">
                <label>Date</label>
                <v-menu
                  ref="menu4"
                  v-model="menu4"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data.gene_xpert_date"
                      outlined
                      dense
                      readonly
                      persistent-hint
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="data.gene_xpert_date"
                    no-title
                    @input="menu4 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="col--padding ml-1" lg="3">
                <label>Result</label>
                <v-select
                  :items="geneResult"
                  v-model="data.gene_xpert_result"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Culture SECTION -->
    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="4">
            <label>Culture</label>
            <v-select
              :items="commonOpt"
              v-model="data.culture_status"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col v-if="data.culture_status == 3" lg="8">
            <v-row>
              <v-col class="col--padding" lg="4">
                <label>Date</label>
                <v-menu
                  ref="menu5"
                  v-model="menu5"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data.culture_date"
                      outlined
                      dense
                      readonly
                      persistent-hint
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="data.culture_date"
                    no-title
                    @input="menu5 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="col--padding ml-1" lg="3">
                <label>Result</label>
                <v-select
                  v-model="data.culture_result"
                  :items="cultureResult"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- DST SECTION -->
    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="3">
            <label>DST</label>
            <v-select
              :items="commonOpt"
              v-model="data.dst_status"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col v-if="data.dst_status == 3" lg="8">
            <v-row>
              <v-col class="col--padding" lg="4">
                <label>Date</label>
                <v-menu
                  ref="menu6"
                  v-model="menu6"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data.dst_date"
                      outlined
                      dense
                      readonly
                      persistent-hint
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="data.dst_date"
                    no-title
                    @input="menu6 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="col--padding ml-1" lg="7">
                <label>Result</label>
                <v-select
                  v-model="computeDstResult"
                  multiple
                  :items="dstResult"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Other Investigation SECTION -->
    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="4">
            <label>Other Investigation</label>
            <v-select
              :items="commonOpt"
              v-model="data.other_investigation_status"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col v-if="data.other_investigation_status == 3" lg="8">
            <v-row>
              <v-col class="col--padding" lg="4">
                <label>Date</label>
                <v-menu
                  ref="menu7"
                  v-model="menu7"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data.other_investigation_date"
                      outlined
                      dense
                      readonly
                      persistent-hint
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="data.other_investigation_date"
                    no-title
                    @input="menu7 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="col--padding pl-2" lg="4">
                <label>Test</label>
                <v-text-field
                  v-model.trim="data.other_investigation_test"
                  type="text"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col class="col--padding pl-2" lg="4">
                <label>Result</label>
                <v-text-field
                  v-model.trim="data.other_investigation_result"
                  type="text"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Conclusion treatment,other comment SECTION -->
    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col lg="4">
            <label>Conclusion/Treatment Received</label>
            <v-select
              :items="conclusons"
              v-model="data.conclusion"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col lg="2">
            <label>Code</label>
            <v-text-field
              v-model.trim="data.conclusion_code"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col lg="7">
            <label>Other Comment</label>
            <v-textarea
              rows="3"
              v-model="data.other_comment"
              placeholder="remark..."
              outlined
              dense
            ></v-textarea>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="emitPresumptiveData" class="form-btn">
            <v-icon left>mdi-chevron-right-circle-outline</v-icon>Submit
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import loaderObj from "@/components/notification/service/loader.js";

export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          weight:null,
          reg_date: null,

          referral_type_id: null,
          referral_from_id: null,
          symptons: [],

          risk_factors: [],

          hiv_status: 1,
          hiv_date: null,
          hiv_result: null,
          hiv_code: null,

          sputum_status: 1,
          sputum_date: null,
          sputum_result: null,

          cxr_status: 1,
          cxr_date: null,
          cxr_result: null,

          gene_xpert_status: 1,
          gene_xpert_date: null,
          gene_xpert_result: null,

          culture_status: 1,
          culture_date: null,
          culture_result: null,

          dst_status: 1,
          dst_date: null,
          dst_result: [],

          other_investigation_test: 1,
          other_investigation_date: null,
          other_investigation_result: null,
          other_investigation_status: null,

          conclusion: null,
          conclusion_code: null,

          other_comment: null,
        };
      },
    },
  },
  data: () => ({
    menu: false,
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    // isValid: false,
  }),
  computed: {
    ...mapState("BasicData", [
      "commonOpt",
      "commonResultOpt",
      "InitialOpt",
      "relationOpt",
    ]),
    ...mapGetters("BasicData", [
      "referralTypeOpt",
      "referralFromOpt",
      "symptonOpt",
      "riskFactorOpt",
      "conclusionsOpt",
      "caseFoundatOpt",
      "hivResult",
      "cxrResult",
      "dstResult",
      "geneResult",
      "sputumResult",
      "cultureResult",
    ]),
    conclusons() {
      var data = [];
      if (this.conclusionsOpt) {
        this.conclusionsOpt.forEach((val) => {
          if (val.id == 1 || val.id == 2) {
            if (this.data.sputum_result == 3) {
              data.push(val);
            }
            else if(this.data.cxr_result == 5){
              data.push(val);
            }
             else if (
              this.data.gene_xpert_result == 4 ||
              this.data.gene_xpert_result == 5
            ) {
              data.push(val);
            } else if (this.data.culture_result == 4) {
              data.push(val);
            } else if (val.id == 1 && this.data.cxr_result == 5) {
              data.push(val);
            }
          } else {
            data.push(val);
          }
        });
      }
      return data;
    },
    // weightRules() {
    //   return [
    //     (value) => {
    //       if (+value < 1 || +value > 100) {
    //         this.isValid = false;
    //         return 'Weight must be between 1 and 100.';
    //       }
    //       this.isValid = true;
    //       return true;
    //     },
    //   ];
    // },
    computeDstResult: {
      get() {
        
        if(typeof this.data.dst_result === 'string'){
          return JSON.parse(this.data.dst_result)
        }
        return this.data.dst_result
      },
      set(val) {
        this.data.dst_result = val.map((v) => {
            return v
        })
      },
    },
  },
  methods: {
    validate() {
      let message = "";

      if (this.data.register_date == null) message += "Reg Date  is required\n";
      if (this.data.referral_type_id == null)
        message += "Referral Type  is required\n";

      if (this.data.sputum_status == 3) {
        if (this.data.sputum_date == null)
          message += "Sputum Date is required\n";
        if (this.data.sputum_result == null)
          message += "Sputum Result is required\n";
      }

      if (this.data.hiv_status == 3) {
        if (this.data.hiv_date == null) message += "Hiv Date is required\n";
        if (this.data.hiv_result == null) message += "Hiv Result is required\n";
      }

      if (this.data.cxr_status == 3) {
        if (this.data.cxr_date == null) message += "CXR Date is required\n";
        if (this.data.cxr_result == null) message += "CXR Result is required\n";
      }

      if (this.data.gene_xpert_status == 3) {
        if (this.data.gene_xpert_date == null)
          message += "Gene Xpert Date is required\n";
        if (this.data.gene_xpert_result == null)
          message += "Gene Xpert Result is required\n";
      }

      if (this.data.culture_status == 3) {
        if (this.data.culture_date == null)
          message += "Culture Date is required\n";
        if (this.data.culture_result == null)
          message += "Culture Result is required\n";
      }

      if (this.data.dst_status == 3) {
        if (this.data.dst_date == null) message += "DST Date is required\n";
        if (this.data.dst_result == null) message += "DST Result is required\n";
      }

      if (this.data.other_investigation_status == 3) {
        if (this.data.other_investigation_date == null)
          message += "Other Investigation Date is required\n";
        if (this.data.other_investigation_result == null)
          message += "Other Investigation Result is required\n";
      }

      if (this.data.symptons.length == 0) message += "Sympton is required\n";

      if (this.data.risk_factors.length == 0)
        message += "Risk Factor is required\n";

        if ( this.data.weight >= 100) {
          message+= 'Weight cannot be greater than 100.\n';
        }

      if (this.data.conclusion == null) message += "Conclusion is required\n";

      if (message.length > 0) {
        this.$toast.error(message, {
          timeout: 2000,
        });
      }

      return message.length > 0 ? false : true;
    },
    emitPresumptiveData() {
   
      if (this.validate()) {
        let data = {
          register_date: this.data.register_date,
          id: this.$route.params.id,
          case_found_at: this.data.case_found_at,
          index_case_initial: this.data.index_case_initial,
          index_case_no: this.data.index_case_no,
          index_case_year: this.data.index_case_year,
          previousID: this.data.previousID,

          referral_type_id: this.data.referral_type_id,
          referral_from_id: this.data.referral_from_id,

          hiv_status: this.data.hiv_status,
          hiv_code: this.data.hiv_code,
          hiv_result: this.data.hiv_result,
          hiv_date: this.data.hiv_date,

          sputum_status: this.data.sputum_status,
          sputum_date: this.data.sputum_date,
          sputum_result: this.data.sputum_result,

          cxr_status: this.data.cxr_status,
          cxr_date: this.data.cxr_date,
          cxr_result:parseInt(this.data.cxr_result),

          gene_xpert_status: this.data.gene_xpert_status,
          gene_xpert_date: this.data.gene_xpert_date,
          gene_xpert_result: this.data.gene_xpert_result,

          culture_status: this.data.culture_status,
          culture_date: this.data.culture_date,
          culture_result: this.data.culture_result,

          dst_status: this.data.dst_status,
          dst_date: this.data.dst_date,
          dst_result: this.data.dst_result,

          other_investigation_status: this.data.other_investigation_status,
          other_investigation_date: this.data.other_investigation_date,
          other_investigation_result: this.data.other_investigation_result,
          other_investigation_test: this.data.other_investigation_test,

          conclusion: this.data.conclusion,
          conclusion_code: this.data.conclusion_code,

          other_comment: this.data.other_comment,
        };
        const symptons = this.data.symptons.map((v) => {
          if (typeof v === "object") return v.id;
          return v;
        });
        const risk_factors = this.data.risk_factors.map((v) => {
          if (typeof v === "object") return v.id;
          return v;
        });
        data.symptons = symptons;
        data.risk_factors = risk_factors;

        data.weight = this.data.weight;

        const loader = this.$loading.show(loaderObj);
      
        this.$store.dispatch("Presumptive/updateTime", data).then(() => {
            loader.hide()
          })
      }
    },
  },
  created() {
    this.$store.dispatch("BasicData/getBasicData");
  },
};
</script>

<style scoped>
.v-card {
  margin: 20px 0px !important;
}
h3,
p {
  margin: 0px;
}
.patient-detail h3,
p {
  font-size: 16px;
}
h3 {
  color: #453f3f;
  letter-spacing: 1px;
  font-weight: 400;
}
.header {
  background-color: #e6e6e6;
  border-radius: 5px;
}
</style>
